import React from 'react';
import '../Css/Contact.css'

const Contact = () => {
  

    return (
        <>
        
          <div className='lg:mt-40 lg:mr-96'id='contact'>
            
          <div className='contact-title'>
            <h1 className='text-white bg-slate-700  inline-block font-bold lg:text-2xl p-2 rounded-lg  lg:mr-52 '>
            Contact Me
            </h1>
          </div>
          <div>
            
          <form  action="https://formsubmit.co/c96a09688321e134409b910d3d912c56" method="POST">      
  <input name="name" type="text" class="feedback-input" placeholder="Name" required />   
  <input name="email" type="email" class="feedback-input" placeholder="Email" required/>
  <input name="subject" type="text" class="feedback-input" placeholder="Subject" required />
  <textarea name="text" class="feedback-input" placeholder="Message" required></textarea>
  <input  type="submit" value="SUBMIT"/>
</form>



          </div>


        </div>
        
        </>
      
    );
};

export default Contact;